import { render, staticRenderFns } from "./question_open.vue?vue&type=template&id=7781e497&scoped=true&"
import script from "./question_open.vue?vue&type=script&lang=js&"
export * from "./question_open.vue?vue&type=script&lang=js&"
import style0 from "./question_open.vue?vue&type=style&index=0&id=7781e497&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7781e497",
  null
  
)

export default component.exports